import Button from '@8x8/oxygen-button'
import styled from 'styled-components'

export default styled(Button).attrs({
  hasShadow: false
})`
  &:disabled {
    border: none;
    background-color: #5E6D7A;
  }

  ${props => props.transparent && `
    background-color: transparent;
    border: none;
    color: #0376da;

    &:hover {
      background-color: #daebfa;
    }
  `}
`
